export default (response) => {
	let MAX_CONTROLS_COUNT = 5;
	let result = Array(MAX_CONTROLS_COUNT).fill(0);
	for (let technology of response?.data ?? []) {
		let controlsCount = technology.controls?.length ?? 0;
		let scotsCount = technology.scots?.length ?? 0;
		let hasRelatedSCOT = scotsCount > 0 || controlsCount > 0;
		if (controlsCount < MAX_CONTROLS_COUNT && (controlsCount === 0 || hasRelatedSCOT)) {
			result[controlsCount] += 1;
		}
	}
	return result;
};
